import React, {Component} from 'react'
import PropTypes from 'prop-types'
import getShirtTemplate from '../../helper/getShirtTemplate'
import ShirtPart from './ShirtPart'

class ShirtTemplate extends Component {
    render() {
        const {type, failedPartials, onUpdateSelectedPart} = this.props
        const shirt = getShirtTemplate(type)

        const {parts} = shirt

        return (
            <div className='ShirtTemplate'>
                <div className='row'>
                    {
                        parts.map(part => {
                            const {key} = part

                            return <ShirtPart isSelected={failedPartials.includes(key)} part={part}
                                              key={`${type}_${key}`} afterSelected={onUpdateSelectedPart}/>
                        })
                    }
                </div>
            </div>
        )
    }
}

ShirtTemplate.propTypes = {
    type: PropTypes.string.isRequired,
    failedPartials: PropTypes.array.isRequired,
    onUpdateSelectedPart: PropTypes.func.isRequired,
}

export default ShirtTemplate
